import { Box, CardMedia, CircularProgress, Stack, Typography } from "@mui/material"
import { useEffect, useRef } from "react";

export const CustomPageLoading = () => {
  return (
    <Stack alignItems="center" justifyContent="center" flexGrow={1}
      width="100%" height="100%" >
      <CircularProgress />
    </Stack>
  )
}

export const ScriptLoading = ({
  textArr, mode, color
}:{
  textArr: string[];
  mode: "dark" | "light";
  color: string;
})=>{
  const timer = useRef<NodeJS.Timeout>(undefined);
  const textRef = useRef<HTMLDivElement>(null);

  const createAnimation = ()=>{
    let list = textArr;
    let index = 0, position = 1, step = 0;
    let cacheTxt = "";
    timer.current = setInterval(()=> {
      if(position === 1){
        if(step < 60) step += 1; else position = -1;
      }else{
        if(step > 0){
          step -= 1;
        }else{
          position = 1;
          index += 1;
          if(index === list.length) index = 0;
        }
      }
      let text = textRef.current;
      if(!text) return;
      let texts = list[index].slice(0, step);
      if(texts === cacheTxt) return;
      text.innerText = texts;
      cacheTxt = texts;
    }, 60);
  };

  useEffect(()=>{
    createAnimation();
    return ()=>{
      clearInterval(timer.current);
    }
  },[]);

  return (
    <Stack justifyContent="center" alignItems="center" width="100%">
      <CardMedia component="img"
        src={mode === "light" ? "/image/loading_while.jpg" : "/image/loading_black.jpg"}
        className="rotates_360deg_cartoon"
        sx={{ width: "1.34rem", height: "1.34rem" }} />
      <Box mt="0.32rem" overflow="hidden" width="100%">
        <Stack direction="row" sx={{
            width: "100%", justifyContent: "center",
            "& >*": { lineHeight: "0.3rem !important" }
          }}>
          <Typography fontSize="0.16rem" color={color} ref={textRef}
            maxWidth="100%"
            sx={{
              "&::after": {
                content: "'|'",
                display: "inline",
                marginLeft: "0.06rem",
                backgroundColor: color,
                animation: "genloading_cartoon 1s linear infinite",
              },
            }}></Typography>
        </Stack>
      </Box>
    </Stack>
  )
}